import config from '../config'
export const fetchBase = ({ apiToken } = {}) => {
  /** @type RequestCredentials */
  const credentials = 'include'

  return {
    credentials,
    headers: {
      ...(apiToken
        ? {
            Authorization: `JWT ${apiToken}`,
          }
        : {}),
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  }
}

export const graphQLBase = (query, extractResult = x => x) => (
  { apiEndpoint, apiToken } = {},
  variables
) => {
  /** @type RequestCredentials */
  const credentials = 'include'

  return fetch(`${apiEndpoint}/graphql?`, {
    credentials,
    headers: {
      ...(apiToken
        ? {
            Authorization: `JWT ${apiToken}`,
          }
        : {}),
      'Content-Type': 'application/json',
      'x-apollo-client-name': config.appName,
      'x-apollo-client-version': config.appVersion,
      Accept: 'application/json',
    },
    method: 'POST',
    body: JSON.stringify({
      query,
      variables,
    }),
  })
    .then(basicGraphQLResponseHandler)
    .then(extractResult)
}

export function makeBody(type, attributes, id) {
  return JSON.stringify({
    data: {
      id,
      type,
      attributes,
    },
  })
}

export class APIReponseError extends Error {
  constructor(message, response) {
    super(message)
    this.response = response
  }
}

export function extractJSON(response) {
  return response.json()
}

export function extractDataAttributes({ data }) {
  return {
    id: data.id, // merge id in attributes
    ...data.attributes,
  }
}

export function extractData({ data }) {
  return data
}

export function throwOnDataErrors(responseData) {
  const { errors } = responseData
  if (errors) {
    throw errors
  }
  return responseData
}

export function rejectResponseAbove(httpCode) {
  return function(response) {
    if (response.status < httpCode) {
      return Promise.resolve(response)
    }
    return response
      .json() // try to extract error message from response
      .then(throwOnDataErrors, function throwRawError() {
        throw new APIReponseError(
          `HTTP Response Status too high: ${response.status}`,
          response
        )
      })
  }
}

export function rejectEmptyResponseAbove(httpCode) {
  return function(response) {
    if (response.status < httpCode) {
      return Promise.resolve(response)
    }
    throw new APIReponseError(
      `HTTP Response Status too high: ${response.status}`,
      response
    )
  }
}

export function basicResponseHandler(response) {
  return rejectResponseAbove(400)(response)
    .then(extractJSON)
    .then(throwOnDataErrors)
    .then(extractDataAttributes)
}

export function basicGraphQLResponseHandler(response) {
  return rejectResponseAbove(400)(response)
    .then(extractJSON)
    .then(throwOnDataErrors)
    .then(extractData)
}

export function arrayResponseHandler(response) {
  return rejectResponseAbove(400)(response)
    .then(extractJSON)
    .then(throwOnDataErrors)
    .then(({ data }) =>
      data.map(({ id, attributes }) => ({ id, ...attributes }))
    )
}
